export const COMPREHENSIVE_HERO_CONTENT = {
  productWidgetMainHeading: 'Comprehensive bike insurance',
  ProductWidgetSubHeading:
    'Covers own damage, theft, fire, flood, and third-party liability. Zero commission, zero hidden charges, and hassle-free claims - trusted by 5 Cr+ Indians',
  productWidgetHeroImageDesktop: 'https://acko-cms.ackoassets.com/bike_comprehensive_hero_73ddf4e77d.webp',
  productWidgetHeroImageMobile: 'https://acko-cms.ackoassets.com/bike_comprehensive_hero_73ddf4e77d.webp',
  KeyFeatures: [
    {
      keyFeatureHighlight: 'Zero commission',
      keyFeatureServiceProvided: 'No middlemen charges',
      KeyFeatureIcon: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/zero_commission_icon_8c978c7e09.svg',
    },
    {
      keyFeatureHighlight: 'Hassle-free claims',
      keyFeatureServiceProvided: 'Fast settlement, zero stress',
      KeyFeatureIcon: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/cashless_repair_icon_4722f6a2a1.svg',
    },
  ],
  widgetHeading: 'Get comprehensive plan in 60 seconds!',
  inputPlaceholder: 'Enter registration number',
  widgetCtaText: 'Check prices',
  disclaimer: 'UID 8192 | T&Cs apply*',
  newFlowBanner: {
    heading: 'Insure your brand new bike',
    subHeading:
      'New bikes are eligible for a bundled comprehensive plan that includes 1-year own damage cover and 5-year TP (third-party) cover.',
    ctaText: 'Get quote',
  },
}
